import { BaseButtonKindEnum } from "@/components/Base/Button";
import BaseDropdownCheckbox from "@/components/Base/Dropdown/Checkbox.vue";
import FilterButtons from "@/components/Filter/Buttons.vue";
import FilterFormDropdown from "@/components/Filter/FormDropdown.vue";
import { Option } from "@/types/components/Base/BaseFormDropdown.types";

export interface FilterParamsBase extends Record<string, unknown> {
  query: string;
  page: string | number;
}

export enum FilterableRoute {
  INDEX = "gallery-index",
  COMMUNITY = "gallery-community",
  TO_TEACH = "gallery-to-teach",
  COLLECTION_SHOW = "collections-show",
}

export type FilterCategory = {
  id: string;
  component: "FilterFormDropdown" | "DropdownCheckbox" | "FilterButtons";
  pages: FilterableRoute[];
  props: {
    id: string;
    label: string;
    options: FilterOption[] | Option[];
    selectedValues?: string[] | "";
    radio?: boolean; // only for FilterButtons
  };
};

export type FilterComponent =
  | typeof FilterFormDropdown
  | typeof BaseDropdownCheckbox
  | typeof FilterButtons;

export type FilterOption = Option & {
  id: string;
  icon?: string;
};

export type { Option };

export type FilterButtonsProps = {
  options?: FilterOption[];
  models?: string[];
  apps?: { id: string; modelName: string; icon: string }[];
  kind?: BaseButtonKindEnum;
  selectedValues: string[] | string;
  radio?: boolean;
};

export type FilterDropdownCheckboxProps = {
  id: string;
  label: string;
  options: Option[];
  kind?: BaseButtonKindEnum;
  selectedValues: string[];
};
